<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-12 admin-table-col" data-drag-drop-container="true">
                <br />
                <br />
                <!-- Header & Toolbar Items -->
                <div class="row pb-4 mt-3">
                    <div class="col-12">
                        <div class="d-lg-flex align-items-center mb-3">
                            <div class="flex-grow-1 d-flex">
                                <!-- Main Library Title -->
                                <div v-if="!currentFolder.id" class="view-header">
                                    <h1 class="mt-1 mb-0 h4 font-weight-bolder align-middle">
                                        Library
                                    </h1>
                                    <p v-if="!loading" class="text-secondary mb-0 small font-weight-500">
                                        {{ orgTotalCaseCount }}
                                        <span v-if="orgTotalCaseCount === 1">Item</span>
                                        <span v-else>Items</span>
                                    </p>
                                </div>
                                <!-- Folder Breadcrumbs -->
                                <ul v-else class="view-header nav d-flex align-items-center mb-0">
                                    <li
                                        class="nav-item"
                                        data-drag-drop="true"
                                        data-item-id="root"
                                        data-drop-only="true"
                                    >
                                        <router-link
                                            :to="{ name: 'OrganizationLibrary' }"
                                            class="nav-link breadcrumb-item"
                                            >Library</router-link
                                        >
                                    </li>
                                    <div
                                        v-for="item in currentFolder.parent_items"
                                        :key="item.id"
                                        class="d-flex align-items-center"
                                    >
                                        <span
                                            class="icon icon-glyphicons-basic-chevron-right text-secondary breadcrumb-chevron"
                                        ></span>
                                        <li
                                            class="nav-item"
                                            :data-drag-drop="item.id !== currentFolder.id"
                                            :data-item-id="item.id"
                                            data-drop-only="true"
                                        >
                                            <router-link
                                                :to="{ name: 'OrganizationLibrary', query: { folder: item.id } }"
                                                class="nav-link breadcrumb-item"
                                                :class="{ active: item.id === currentFolder.id }"
                                                >{{ trimString(item.folder_name, 26) }}
                                            </router-link>
                                        </li>
                                    </div>
                                </ul>
                            </div>
                            <div class="flex-grow-0 d-flex align-items-end">
                                <div class="d-flex justify-content-lg-end flex-grow-1">
                                    <div class="flex-shrink-0 pt-3 pt-lg-0 pl-lg-4">
                                        <div class="d-flex">
                                            <!-- Sort Ascending/Descending -->
                                            <div
                                                class="btn-toolbar mr-2"
                                                role="toolbar"
                                                aria-label="Library sort toolbar"
                                            >
                                                <div class="btn-group" role="group" aria-label="First group">
                                                    <button
                                                        type="button"
                                                        class="btn btn-light btn-sm"
                                                        @click="sortDescending = false"
                                                        :class="{ active: !sortDescending }"
                                                        aria-label="Sort learning experiences in descending order"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-arrow-up align-middle"></span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        class="btn btn-light btn-sm"
                                                        @click="sortDescending = true"
                                                        :class="{ active: sortDescending }"
                                                        aria-label="Sort learning experiences in ascending order"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-arrow-down align-middle"></span>
                                                    </button>
                                                </div>
                                            </div>
                                            <!-- Sort Field Dropdown -->
                                            <div class="dropdown mr-2">
                                                <a
                                                    class="btn btn-light btn-sm"
                                                    href="#"
                                                    role="button"
                                                    id="sortFieldDropdown"
                                                    data-toggle="dropdown"
                                                    aria-haspopup="true"
                                                    aria-expanded="false"
                                                    aria-label="Select sort field"
                                                >
                                                    <span class="align-middle">Sort: {{ sortFieldDisplay(sortField) }}</span>
                                                    <span
                                                        class="small icon-glyphicons-basic-chevron-down chevron align-middle ml-1"
                                                    ></span>
                                                </a>
                                                <div
                                                    class="dropdown-menu shadow-sm"
                                                    aria-labelledby="sortFieldDropdown"
                                                >
                                                    <a class="dropdown-item" @click="sortField = 'title'">Title</a>
                                                    <a class="dropdown-item" @click="sortField = 'last_modified'">
                                                        Last Modified
                                                    </a>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="dropdown">
                                                    <a
                                                        class="btn btn-primary btn-sm"
                                                        href="#"
                                                        role="button"
                                                        id="newDropdown"
                                                        data-toggle="dropdown"
                                                        data-offset="0,5"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                        aria-label="Select sort field"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-plus align-middle mr-1"></span>
                                                        <span class="align-middle">New</span>
                                                    </a>
                                                    <div
                                                        class="dropdown-menu dropdown-menu-right shadow-sm medium"
                                                        aria-labelledby="newDropdown"
                                                    >
                                                        <a
                                                            class="dropdown-item py-2"
                                                            role="button"
                                                            @click="openCreateItem('owned_case')"
                                                        >
                                                            <div class="d-flex">
                                                                <div class="flex-grow-0">
                                                                    <span
                                                                        class="icon icon-100 icon-glyphicons-basic-layers align-middle mr-2"
                                                                    ></span>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <p class="create-item-label">Learning Experience</p>
                                                                    <p class="text-secondary small mb-0">
                                                                        Create or add a new learning experience.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </a>
                                                        <a
                                                            class="dropdown-item py-2"
                                                            role="button"
                                                            @click="openCreateItem('folder')"
                                                        >
                                                            <div class="d-flex">
                                                                <div class="flex-grow-0">
                                                                    <span
                                                                        class="icon icon-100 icon-glyphicons-basic-folder align-middle mr-2"
                                                                    ></span>
                                                                </div>
                                                                <div class="flex-grow-1">
                                                                    <p class="create-item-label">Folder</p>
                                                                    <p class="text-secondary small mb-0">
                                                                        Use folders to organize your workspace.
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Item List -->
                <div class="pb-3">
                    <div v-for="(item, index) in libraryItems" :key="item.id">
                        <div class="d-flex flex-column flex-md-row align-items-md-center">
                            <div class="flex-grow-0 library-item-container">
                                <div v-if="item.item_type === 'owned_case'" class="case-cover-container">
                                    <router-link
                                        :to="{ name: 'CaseSettings', params: { id: item.case.id } }"
                                        class="no-decor"
                                    >
                                        <library-case-card
                                            :case-obj="item.case"
                                            data-drag-drop="true"
                                            :data-item-id="item.id"
                                        ></library-case-card>
                                    </router-link>
                                </div>
                                <div
                                    v-else-if="item.item_type === 'community_reference'"
                                    class="position-relative case-cover-container"
                                >
                                    <a :href="viewInCommunityLink(item)" target="_blank">
                                        <library-case-card
                                            :case-obj="item.case"
                                            data-drag-drop="true"
                                            :data-item-id="item.id"
                                            ><span
                                                class="icon icon-glyphicons-basic-world-east community-watermark"
                                            ></span>
                                        </library-case-card>
                                    </a>
                                </div>
                                <div v-else-if="item.item_type === 'folder'" class="folder-container">
                                    <router-link :to="{ name: 'OrganizationLibrary', query: { folder: item.id } }">
                                        <div data-drag-drop="true" :data-item-id="item.id">
                                            <div
                                                class="d-flex flex-column align-items-center justify-content-center folder-icon-container mb-3 mb-md-0"
                                            >
                                                <div>
                                                    <span class="icon icon-glyphicons-basic-folder folder-icon"></span>
                                                </div>
                                                <div class="folder-text">
                                                    <span class="text-body tiny">
                                                        {{ item.child_item_count || 0 }}
                                                        <span v-if="item.child_item_count === 1">Item</span>
                                                        <span v-else>Items</span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </router-link>
                                </div>
                            </div>
                            <div class="flex-grow-1 mb-3 mb-md-0">
                                <div class="metadata-container">
                                    <div v-if="item.item_type === 'owned_case'">
                                        <div class="my-1">
                                            <p class="h6 d-inline-block">
                                                <router-link
                                                    :to="{ name: 'CaseSettings', params: { id: item.case.id } }"
                                                    class="no-decor text-body max-one-line"
                                                    >{{ item.title }}</router-link
                                                >
                                            </p>
                                            <p v-if="item.description" class="small mb-2 mr-xl-4 max-one-line">
                                                {{ item.description }}
                                            </p>
                                            <p class="small text-secondary mb-0">
                                                Last modified by {{ item.case.last_modified_by.email }} on
                                                {{ formatDateTime(item.case.last_modified) }}
                                            </p>
                                        </div>
                                        <div v-if="organizationLMSAuthConfigured" class="d-inline-block">
                                            <info-popover
                                                :content="getItemLMSStatusText(item)"
                                                justify="left"
                                                placement="right"
                                                class="d-inline mr-1"
                                            >
                                                <button
                                                    class="btn btn-light badge badge-light case-badge default-cursor"
                                                    @click="openLMSSettingsModal(item)"
                                                >
                                                    <span
                                                        :class="{
                                                            'icon-glyphicons-basic-power-cord-plug':
                                                                item.case.show_in_lms_deep_link,
                                                            'icon-glyphicons-basic-power-cord-plug-off':
                                                                !item.case.show_in_lms_deep_link,
                                                        }"
                                                        class="icon align-middle mr-xs"
                                                    ></span>
                                                    <span class="align-middle">LMS</span>
                                                </button>
                                            </info-popover>
                                        </div>
                                        <a
                                            v-if="item.case.community_published_status == 'published'"
                                            class="badge badge-highlight case-badge mr-1"
                                            :href="viewInCommunityLink(item)"
                                            target="_blank"
                                        >
                                            <span
                                                class="icon icon-glyphicons-basic-world-east align-middle mr-xs"
                                            ></span>
                                            <span class="align-middle">Published</span>
                                        </a>
                                        <span
                                            v-else-if="item.case.community_published_status == 'in_review'"
                                            class="badge badge-highlight case-badge mr-1"
                                        >
                                            <span
                                                class="icon icon-glyphicons-basic-world-east align-middle mr-xs"
                                            ></span>
                                            <span class="align-middle">In Review</span>
                                        </span>
                                        <span
                                            v-if="item.case.community_published_status == 'published'"
                                            class="case-badge font-weight-bolder text-secondary mx-1"
                                        >
                                            <span class="icon icon-glyphicons-basic-trending align-middle mr-xs"></span>
                                            <span class="align-middle"
                                                >{{ formatViewCount(item.case.view_count) }} Views</span
                                            >
                                        </span>
                                    </div>
                                    <div v-else-if="item.item_type === 'community_reference'">
                                        <p class="mb-2 h6 max-one-line">{{ item.title }}</p>
                                        <p class="small mb-2 mr-xl-4 max-one-line">{{ item.description }}</p>
                                        <p class="small text-secondary mb-1">
                                            Added by {{ item.created_by.email }} on
                                            {{ formatDateTime(item.created) }}
                                        </p>
                                        <div class="d-inline-block align-middle mr-1">
                                            <a
                                                class="badge badge-light case-badge mr-1"
                                                :href="viewInCommunityLink(item)"
                                                target="_blank"
                                                style="height: 18px"
                                            >
                                                <span class="align-middle mr-xs">From Community</span>
                                                <span
                                                    class="icon icon-glyphicons-basic-square-new-window align-middle"
                                                ></span>
                                            </a>
                                        </div>
                                        <div v-if="organizationLMSAuthConfigured" class="d-inline-block align-middle">
                                            <info-popover
                                                :content="getItemLMSStatusText(item)"
                                                justify="left"
                                                placement="right"
                                                class="d-inline mr-1"
                                            >
                                                <button
                                                    class="btn btn-light badge badge-light case-badge default-cursor"
                                                    @click="openLMSSettingsModal(item)"
                                                >
                                                    <span
                                                        :class="{
                                                            'icon-glyphicons-basic-power-cord-plug':
                                                                item.show_in_lms_deep_link,
                                                            'icon-glyphicons-basic-power-cord-plug-off':
                                                                !item.show_in_lms_deep_link,
                                                        }"
                                                        class="icon align-middle mr-xs"
                                                    ></span>
                                                    <span class="align-middle">LMS</span>
                                                </button>
                                            </info-popover>
                                        </div>
                                    </div>
                                    <div v-else-if="item.item_type === 'folder'">
                                        <p class="mb-2 h6 max-one-line">{{ item.folder_name }}</p>
                                        <p class="small text-secondary mb-1">
                                            Last modified by
                                            <span v-if="item.last_modified_by">{{ item.last_modified_by.email }}</span>
                                            on
                                            {{ formatDateTime(item.last_modified) }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <!-- Item Actions -->
                                <div class="pl-0 pl-lg-5 ml-0 ml-md-5 flex-shrink-0">
                                    <div class="d-flex justify-content-md-end">
                                        <button
                                            v-if="item.item_type !== 'community_reference'"
                                            @click="openEditItemAccess(item)"
                                            class="btn btn-light btn-sm mr-1"
                                        >
                                            <span class="icon icon-glyphicons-basic-user"></span>
                                        </button>
                                        <button
                                            v-if="item.item_type !== 'folder'"
                                            @click="openCloneItem(item)"
                                            class="btn btn-light btn-sm mr-1"
                                        >
                                            <span class="icon icon-glyphicons-basic-squares"></span>
                                        </button>
                                        <div class="dropdown d-inline">
                                            <button
                                                class="btn btn-light btn-sm"
                                                type="button"
                                                aria-label="More options"
                                                data-toggle="dropdown"
                                            >
                                                <span class="icon icon-lg icon-glyphicons-basic-more-vertical"></span>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right shadow-sm medium">
                                                <div v-if="item.item_type !== 'community_reference'">
                                                    <h6 class="dropdown-header">Access</h6>
                                                    <button
                                                        class="dropdown-item"
                                                        @click="openEditItemAccess(item)"
                                                        role="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-user icon-mr"></span>
                                                        <span class="align-middle">Author Access</span>
                                                    </button>
                                                    <div class="dropdown-divider"></div>
                                                </div>
                                                <div v-if="item.item_type !== 'folder'">
                                                    <h6 class="dropdown-header">LMS</h6>
                                                    <button
                                                        class="dropdown-item"
                                                        @click="openLMSSettingsModal(item)"
                                                        role="button"
                                                    >
                                                        <span
                                                            class="icon icon-glyphicons-basic-power-cord-plug icon-mr"
                                                        ></span>
                                                        <span class="align-middle">Publish to LMS</span>
                                                    </button>
                                                    <button
                                                        class="dropdown-item"
                                                        @click="openLMSEmbedModal(item)"
                                                        role="button"
                                                    >
                                                        <span class="icon icon-glyphicons-basic-link icon-mr"></span>
                                                        <span class="align-middle">LTI Launch Link</span>
                                                    </button>
                                                    <div class="dropdown-divider"></div>
                                                </div>
                                                <div v-if="item.item_type !== 'folder'">
                                                    <h6 class="dropdown-header">Community</h6>
                                                    <button
                                                        v-if="item.item_type === 'owned_case'"
                                                        class="dropdown-item"
                                                        @click="openPublish(item)"
                                                        role="button"
                                                    >
                                                        <span
                                                            class="icon icon-glyphicons-basic-world-east icon-mr"
                                                        ></span>
                                                        <span class="align-middle">Submit to Community</span>
                                                    </button>
                                                    <a
                                                        class="dropdown-item"
                                                        v-if="
                                                            item.case &&
                                                            (item.case.community_published_status === 'published' ||
                                                                item.item_type === 'community_reference')
                                                        "
                                                        :href="viewInCommunityLink(item)"
                                                        target="_blank"
                                                    >
                                                        <span
                                                            class="icon icon-glyphicons-basic-square-new-window icon-mr"
                                                        ></span>
                                                        <span class="align-middle">View In Community</span>
                                                    </a>
                                                    <div class="dropdown-divider"></div>
                                                </div>
                                                <h6 class="dropdown-header">Actions</h6>
                                                <button class="dropdown-item" @click="openMoveItem(item)" role="button">
                                                    <span class="icon icon-mr icon-glyphicons-basic-folder"></span>
                                                    <span class="align-middle">Move</span>
                                                </button>
                                                <button
                                                    v-if="item.item_type === 'folder'"
                                                    class="dropdown-item"
                                                    @click="openEditFolder(item)"
                                                    role="button"
                                                >
                                                    <span class="icon icon-mr icon-glyphicons-basic-square-edit"></span>
                                                    <span class="align-middle">Edit Name</span>
                                                </button>
                                                <button
                                                    v-if="item.item_type === 'owned_case'"
                                                    class="dropdown-item"
                                                    @click="openEditCase(item)"
                                                    role="button"
                                                >
                                                    <span class="icon icon-mr icon-glyphicons-basic-square-edit"></span>
                                                    <span class="align-middle">Edit Info</span>
                                                </button>
                                                <button
                                                    v-if="item.item_type !== 'folder'"
                                                    class="dropdown-item"
                                                    @click="openCloneItem(item)"
                                                    role="button"
                                                >
                                                    <span class="icon icon-mr icon-glyphicons-basic-squares"></span>
                                                    <span class="align-middle">Clone</span>
                                                </button>
                                                <button
                                                    class="dropdown-item"
                                                    @click="openRemoveItem(item)"
                                                    role="button"
                                                >
                                                    <span class="icon icon-mr icon-glyphicons-basic-bin"></span>
                                                    <span class="align-middle">Remove</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr v-show="index + 1 !== libraryItems.length" class="list-divider" />
                    </div>
                </div>

                <!-- Empty Folder Display -->
                <div v-if="currentFolderEmpty" class="col-12 admin-table-col pt-5">
                    <div class="d-flex justify-content-center mb-3 mt-3 pt-5">
                        <span
                            class="icon icon-glyphicons-basic-folder-open text-secondary"
                            style="font-size: 100px"
                        ></span>
                    </div>
                    <div>
                        <p class="text-center text-secondary font-weight-500 mb-3">This folder is currently empty.</p>
                        <div class="d-flex justify-content-center mb-4 mt-4">
                            <button @click="openCreateItem('owned_case')" type="button" class="btn btn-primary">
                                <span class="icon icon-100 icon-glyphicons-basic-plus"></span> Create
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Empty Data Display -->
                <div v-else-if="currentItemListEmpty" class="col-12 admin-table-col pt-5">
                    <div class="d-flex justify-content-center mb-4 pb-2 pt-5">
                        <img src="/static/general/img/undraw_box.svg" height="200" alt="" />
                    </div>
                    <div>
                        <p class="text-center text-secondary font-weight-500 mb-3">Your workspace is currently empty.</p>
                        <div class="d-flex justify-content-center mb-4 mt-4">
                            <button @click="openCreateItem('owned_case')" type="button" class="btn btn-primary">
                                <span class="icon icon-100 icon-glyphicons-basic-plus mr-1"></span>
                                <span>New</span>
                            </button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <p class="text-center text-secondary small mt-2">
                            Need a walkthrough? Let us know at
                            <a href="mailto:support@affinitylearning.ca?subject=Walkthrough Request" target="_blank">
                                support@affinitylearning.ca</a
                            >
                        </p>
                    </div>
                </div>

                <!-- Pagination -->
                <div v-else-if="isInitialized">
                    <div class="row align-items-center mt-3 mb-3">
                        <div class="col-12 col-md-6 text-center text-sm-left">
                            <span v-show="currentPageEnd !== 0" class="text-secondary">
                                Showing {{ currentPageStart }} to {{ currentPageEnd }} of {{ folderItemsCount }} items.
                            </span>
                            <span v-show="currentPageEnd === 0" class="text-secondary">
                                Showing {{ folderItemsCount }} items.
                            </span>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap align-items-center">
                        <div v-show="numberOfPages > 1" class="mr-3">
                            <nav class="mb-0">
                                <ul class="pagination pagination-sm flex-wrap mb-0">
                                    <li
                                        :class="{ disabled: currentPage === 0 }"
                                        class="page-item pagination-first my-1"
                                    >
                                        <a @click="setCurrentPage(currentPage - 1)" class="page-link" tabindex="-1">
                                            <span class="icon icon-glyphicons-basic-chevron-left"></span>
                                        </a>
                                    </li>
                                    <li
                                        v-for="page in numberOfPages"
                                        :key="page"
                                        :class="{ active: currentPage === page - 1 }"
                                        class="page-item my-1 float-left"
                                    >
                                        <a @click="setCurrentPage(page - 1)" class="page-link" tabindex="-1">{{
                                            page
                                        }}</a>
                                    </li>
                                    <li :class="{ disabled: currentPage === numberOfPages - 1 }" class="page-item my-1">
                                        <a @click="setCurrentPage(currentPage + 1)" class="page-link" tabindex="-1">
                                            <span class="icon icon-glyphicons-basic-chevron-right"></span>
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div v-show="folderItemsCount > resultsPerPageOptions[0]">
                            <div class="d-flex align-items-center">
                                <select class="form-control form-control-sm" v-model="resultsPerPage">
                                    <option v-for="option in resultsPerPageOptions" :key="option" :value="option">
                                        {{ option }}
                                    </option>
                                </select>
                                <div class="ml-2 text-secondary nowrap">
                                    <span>rows per page</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Capacity Reached Modal -->
        <base-modal id="cap-reached-modal" :centered="true">
            <template slot="title"> Learning Experience Capacity Reached </template>
            <template>
                <div class="d-flex justify-content-center mb-4 pb-2">
                    <img src="/static/general/img/undraw_box.svg" height="150" alt="" />
                </div>
                <div class="mb-2">
                    <p class="font-weight-500 text-center mb-3">
                        <span class="align-middle">
                            You've reached the Basic Plan limit of
                            <span class="font-weight-bolder">{{ caseCapacity }}</span> learning experience.
                        </span>
                    </p>
                    <p class="text-center mb-3">
                        To create more learning experiences,
                        <a
                            v-if="userCanAccessBillingPortal"
                            href="#"
                            @click="$refs.billingView.open()"
                            data-dismiss="modal"
                            >upgrade your plan</a
                        >
                        <span v-else>contact your administrator</span>.
                    </p>
                    <support-request-prompt class="text-center" />
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button disabled class="btn btn-primary" type="button">Create</button>
            </template>
        </base-modal>

        <!-- Create Item Modal -->
        <base-modal id="create-modal" :loading="modalLoading" :centered="true" v-on:closed="handleCreateClosed()">
            <template slot="title">
                <span
                    class="icon icon-100 icon-glyphicons-basic-folder align-middle mr-2 text-secondary"
                    v-show="newItem.item_type === 'folder'"
                ></span>
                <span class="align-middle">New {{ newItemModalTitle }}</span>
            </template>
            <template>
                <div v-show="['owned_case', 'community_reference'].includes(newItem.item_type)">
                    <ul class="nav mb-3 mt-2">
                        <li
                            class="nav-item tab-nav tab-nav-highlight mr-2"
                            @click="createType = 'create'"
                            role="button"
                        >
                            <div class="nav-link tab-nav-link" :class="{ active: createType == 'create' }">
                                <div class="text-center">
                                    <span class="icon icon-xl icon-glyphicons-basic-pencil align-middle"></span>
                                </div>
                                <div class="small text-secondary mt-1">Blank Project</div>
                            </div>
                        </li>
                        <li
                            v-if="organizationId === 357"
                            class="nav-item tab-nav tab-nav-highlight mr-2"
                            @click="createType = 'prompt'"
                            role="button"
                        >
                            <div class="nav-link tab-nav-link" :class="{ active: createType == 'prompt' }">
                                <div class="text-center">
                                    <img
                                        v-show="createType === 'prompt'"
                                        src="/static/general/img/icons/shines.svg"
                                        class="align-middle shines-icon"
                                    />
                                    <img
                                        v-show="createType !== 'prompt'"
                                        src="/static/general/img/icons/shines-grey.svg"
                                        class="align-middle shines-icon"
                                    />
                                </div>
                                <div class="small text-secondary mt-1">
                                    Start with a Prompt
                                </div>
                            </div>
                        </li>
                        <li
                            class="nav-item tab-nav tab-nav-highlight mr-1"
                            @click="createType = 'community'"
                            role="button"
                        >
                            <span class="nav-link tab-nav-link" :class="{ active: createType == 'community' }">
                                <div class="text-center">
                                    <span class="icon icon-xl icon-glyphicons-basic-world-east"></span>
                                </div>
                                <div class="small text-secondary mt-1">Add from Community</div>
                            </span>
                        </li>
                    </ul>
                    <div v-show="createType == 'create'">
                        <base-form v-model="newItem" :fields="newItemFormFields" ref="createCaseForm"></base-form>
                    </div>
                    <div v-show="createType == 'prompt'" class="mt-4 pt-2">
                        <textarea-auto-expand
                            v-model="newItem.prompt"
                            class="form-control form-control-sm mb-2"
                            placeholder="Describe the learning experience you'd like to create..."
                            rows="6"
                        ></textarea-auto-expand>
                        <div class="mt-4 pt-3 pb-1">
                            <file-upload
                                v-model="newItem.uploaded_file"
                                :max-bytes="1000000000"
                                :direct-upload="true"
                                file-type-label="attachment"
                                placeholder="Drop a file here"
                                accept="Any file type"
                                size="xs"
                            ></file-upload>
                        </div>
                        <div class="small text-secondary mt-4 pt-2">
                            <span class="badge badge-highlight align-middle mr-1">
                                <span class="icon icon-100 icon-glyphicons-basic-chemistry-alt mr-xs"></span>
                                <span>Experimental</span>
                            </span>
                            <span class="align-middle">
                                <span>You have early access to this feature.</span>
                                <a href="mailto:feedback@affinitylearning.ca?subject=Feature Feedback - Prompt to Create">
                                    Feedback is welcome.
                                </a>
                            </span>
                        </div>
                    </div>
                    <div v-show="createType == 'community'">
                        <div class="d-flex flex-column align-items-center py-5">
                            <a
                                @click="browseCommunityLibrary()"
                                :href="communityBrowseURL"
                                rel="noopener"
                                target="_blank"
                                class="mb-3"
                            >
                                <span class="icon icon-glyphicons-basic-search mr-1 align-middle"></span>
                                <span class="align-middle">Browse the Community Library</span>
                            </a>
                            <p class="text-secondary">
                                Press the "<span class="icon icon-100 icon-glyphicons-basic-plus align-middle"></span>" button to
                                add learning experiences to your workspace.
                            </p>
                        </div>
                    </div>
                </div>
                <div v-show="newItem.item_type === 'folder'">
                    <base-form v-model="newItem" :fields="newItemFormFields" ref="createFolderForm"></base-form>
                </div>
            </template>
            <template slot="footer">
                <div class="flex-grow-1 d-flex">
                    <div class="flex-grow-0" v-show="creationInProgress && createType === 'prompt'">
                        <div class="small text-light-wave ml-1">Building your learning experience...</div>
                    </div>
                </div>
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    v-show="newItem.item_type !== 'community_reference'"
                    @click="createItem()"
                    :disabled="!createBtnEnabled"
                    class="btn btn-primary"
                    type="button"
                >
                    Create
                </button>
            </template>
        </base-modal>

        <!-- Remove Item Modal -->
        <base-modal id="remove-modal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-bin icon-mr"></span>
                <span>Remove Item</span>
            </template>
            <template>
                <p v-if="selectedItemIsRemovable" class="mt-3">
                    Remove <strong>{{ selectedItem.title }}</strong
                    >?
                </p>
                <p v-else-if="!isSelectedItemOwner" class="mt-3 text-secondary text-center">
                    Only admins and owners can remove this item.
                </p>
                <p v-else class="mt-3">Folders with contents can't be removed.</p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button @click="removeItem()" :disabled="!removeBtnIsEnabled" class="btn btn-danger" type="button">
                    Remove
                </button>
            </template>
        </base-modal>

        <!-- Move Item Modal -->
        <base-modal id="move-modal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-folder icon-mr"></span>
                <span>Move Item</span>
            </template>
            <template>
                <div v-show="isSelectedItemOwner">
                    <p>
                        Select a new location for <strong>{{ selectedItem.title }}</strong
                        >.
                    </p>
                    <library-item-selector
                        v-model="moveToFolder"
                        :disabled="!isSelectedItemOwner"
                        :item-types="['folder']"
                        placeholder="Select a folder..."
                        emptyText="No folders found."
                        ref="folderSelector"
                    ></library-item-selector>
                </div>
                <p v-show="!isSelectedItemOwner" class="mt-3 text-secondary text-center">
                    Only admins and owners can move this item.
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="moveItem()"
                    :disabled="!isSelectedItemOwner || loading || !moveToFolder"
                    class="btn btn-primary"
                    type="button"
                >
                    Move
                </button>
            </template>
        </base-modal>

        <!-- Remove Item No-Permission Modal -->
        <base-modal id="move-permission-modal" :loading="modalLoading" :centered="true" size="small">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-circle-alert icon-mr"></span>
                <span>Insufficient Permissions</span>
            </template>
            <template>
                <p class="mt-3 text-secondary text-center">You don't have permission to move this item.</p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
            </template>
        </base-modal>

        <!-- Clone Item Modal -->
        <base-modal id="clone-modal" :loading="modalLoading" :centered="true">
            <template slot="title"> Clone </template>
            <template>
                <p>
                    Clone learning experience <strong>{{ selectedItem.title }}</strong
                    >?
                </p>
                <p class="mb-0 text-secondary">
                    <span class="icon icon-lg icon-glyphicons-basic-circle-alert align-middle"></span>
                    <span class="align-middle">
                        The cloning process can take a few minutes - please do not close your browser window or refresh
                        the page once cloning has begun.
                    </span>
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="cloneItem()"
                    :disabled="modalLoading || capacityIsReached"
                    class="btn btn-primary"
                    type="button"
                >
                    Clone
                </button>
            </template>
        </base-modal>

        <!-- Editable Clone Modal -->
        <base-modal id="editable-clone-modal" :loading="modalLoading" :centered="true">
            <template slot="title"> Create Editable Clone </template>
            <template>
                <div v-if="selectedItem.case">
                    <p class="mb-4">
                        Create an editable clone of <strong>{{ selectedItem.case.title }}</strong
                        >?
                    </p>
                    <div class="mb-2 pb-1">
                        <img
                            src="/static/general/img/icons/ccattribsharealike.svg"
                            height="21"
                            alt="Creative Commons Attribution-ShareAlike Logos"
                        />
                    </div>
                    <p>
                        This content is licensed as an open educational resource under
                        <a :href="creativeCommonsLicenseUrl" target="_blank" rel="noopener">
                            Creative Commons Attribution-ShareAlike 4.0 International (CC BY-SA 4.0)</a
                        >. You can remix, transform, and build upon the material for any purpose, but adaptations must
                        hold the same license as the original. Creative Commons licensing will automatically be added to
                        your cloned learning experience.
                    </p>
                    <p v-if="selectedItem.case.id">
                        <a
                            :href="viewInCommunityLink(selectedItem)"
                            target="_blank"
                            aria-label="Learn more about this resource"
                            >View Original Work<span
                                class="icon-glyphicons-basic-square-new-window ml-1 align-middle"
                            ></span
                        ></a>
                    </p>
                    <hr />
                    <p class="mb-2 text-secondary">
                        <span class="icon icon-lg icon-glyphicons-basic-circle-alert align-middle"></span>
                        <span class="align-middle">
                            The cloning process can take a few minutes - please do not close your browser window or
                            refresh the page once cloning has begun.
                        </span>
                    </p>
                </div>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="cloneItem()"
                    :disabled="modalLoading || capacityIsReached"
                    class="btn btn-primary"
                    type="button"
                >
                    Create Editable Clone
                </button>
            </template>
        </base-modal>

        <!-- Item Access Modal -->
        <base-modal id="item-access-modal" :loading="accessModalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-user icon-mr"></span>
                <span>Author Access</span>
            </template>
            <template>
                <author-access-form
                    v-if="selectedItem.id"
                    v-model="selectedItem"
                    :loading.sync="accessModalLoading"
                ></author-access-form>
            </template>
            <template slot="footer">
                <button class="btn btn-light" type="button" data-dismiss="modal">Done</button>
            </template>
        </base-modal>

        <!-- Folder Item Edit Modal -->
        <base-modal id="folder-edit-modal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span>Edit Name</span>
            </template>
            <template>
                <base-form
                    v-model="selectedItem"
                    :fields="folderItemFormFields"
                    :condensed-style="true"
                    class="mt-2"
                ></base-form>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="saveFolder()"
                    :disabled="modalLoading || !selectedItem.folder_name"
                    class="btn btn-primary"
                    type="button"
                >
                    Save
                </button>
            </template>
        </base-modal>

        <!-- LMS Link Modal -->
        <base-modal id="lms-embed-modal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-link icon-mr"></span>
                <span>Copy LMS LTI Launch Link</span>
            </template>
            <template>
                <div v-if="organizationLMSAuthConfigured" class="alert alert-info small p-2 mt-1 mb-3">
                    <span class="icon icon-glyphicons-basic-circle-alert"></span>
                    If your LMS supports deep linking, you can add this learning experience to a course from directly within your
                    LMS.
                    <a
                        href="#"
                        @click.prevent="openLMSSettingsModal(selectedItem)"
                        data-dismiss="modal"
                        v-if="selectedItem.case && !selectedItem.case.show_in_lms_deep_link"
                        >Make this learning experience visible in your LMS.</a
                    >
                </div>
                <lti-launch-form
                    v-if="selectedItem.case"
                    :case-obj="selectedItem.case"
                    ref="ltiLaunchForm"
                ></lti-launch-form>
            </template>
        </base-modal>

        <!-- LMS Not Configured Modal -->
        <base-modal id="lms-not-configured-modal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-link icon-mr"></span>
                <span>LMS Not Configured</span>
            </template>
            <template>
                <lti-not-configured></lti-not-configured>
            </template>
        </base-modal>

        <!-- LMS Settings Modal -->
        <base-modal ref="lmsSettingsModal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span class="icon icon-glyphicons-basic-power-cord-plug icon-mr"></span>
                <span class="align-middle">Publish to LMS</span>
            </template>
            <template>
                <div v-if="selectedItem.item_type === 'owned_case'">
                    <base-form
                        v-model="selectedCase"
                        :fields="lmsFormFields"
                        :condensed-style="true"
                        :disabled="!isSelectedItemEditor"
                        class="mt-2"
                    ></base-form>
                </div>
                <div v-else>
                    <base-form
                        v-model="selectedItem"
                        :fields="lmsFormFields"
                        :condensed-style="true"
                        :disabled="!isSelectedItemEditor"
                        class="mt-2"
                    ></base-form>
                </div>
                <p v-show="!isSelectedItemEditor" class="mt-3 text-center text-secondary">
                    You don't have permission to update this setting.
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="saveLMSSettings()"
                    class="btn btn-primary"
                    :disabled="modalLoading || !isSelectedItemEditor"
                >
                    Save
                </button>
            </template>
        </base-modal>

        <!-- Case Edit Modal -->
        <base-modal ref="caseEditModal" :loading="modalLoading" :centered="true">
            <template slot="title">
                <span>Edit Name & Description</span>
            </template>
            <template>
                <base-form
                    v-model="selectedCase"
                    :fields="caseFormFields"
                    :condensed-style="true"
                    :disabled="!isSelectedItemEditor"
                    ref="editCaseForm"
                ></base-form>
                <p v-show="!isSelectedItemEditor" class="mt-4 text-center text-secondary">
                    You don't have permission to update this info.
                </p>
            </template>
            <template slot="footer">
                <button class="btn btn-secondary" type="button" data-dismiss="modal">Close</button>
                <button
                    @click="saveCaseSettings()"
                    class="btn btn-primary"
                    :disabled="modalLoading || !isSelectedItemEditor"
                >
                    Save
                </button>
            </template>
        </base-modal>

        <!-- Community Publish Modal -->
        <community-publish-modal
            :selected-case="selectedItemCase"
            v-on:submitted="fetchData()"
            ref="communityPublishModal"
        ></community-publish-modal>

        <billing-view ref="billingView"></billing-view>
    </div>
</template>

<script>
import http from "@/axios.js"
import BaseModal from "@/components/BaseModal"
import BaseForm from "@/components/BaseForm"
import Utilities from "@/assets/js/utilities.js"
import CommunityPublishModal from "@/components/CommunityPublishModal"
import BillingView from "@/components/BillingView"
import LibraryCaseCard from "@/components/LibraryCaseCard"
import SupportRequestPrompt from "@/components/SupportRequestPrompt"
import AuthorAccessForm from "@/components/AuthorAccessForm"
import LibraryItemSelector from "@/components/LibraryItemSelector"
import LtiLaunchForm from "@/components/LtiLaunchForm"
import InfoPopover from "@/components/InfoPopover"
import LtiNotConfigured from "@/components/LtiNotConfigured"
import TextareaAutoExpand from "@/components/TextareaAutoExpand"
import FileUpload from "@/components/FileUpload"
import { Draggable } from "@shopify/draggable"

export default {
    name: "OrganizationLibrary",
    components: {
        BaseModal,
        BaseForm,
        CommunityPublishModal,
        BillingView,
        LibraryCaseCard,
        SupportRequestPrompt,
        AuthorAccessForm,
        LibraryItemSelector,
        LtiLaunchForm,
        InfoPopover,
        LtiNotConfigured,
        TextareaAutoExpand,
        FileUpload,
    },
    data() {
        return {
            isInitialized: false,
            currentFolderId: null,
            // The current folder being viewed.
            currentFolder: {
                parent_items: [],
            },
            libraryItems: [],
            // Total count of items in the current folder (or root).
            folderItemsCount: null,
            // Total count of cases (owned or community) that the organization holds.
            orgTotalCaseCount: null,
            selectedItem: {
                case: {},
            },
            selectedCase: {},
            isSelectedItemEditor: true,
            isSelectedItemOwner: false,
            selectedItemIsRemovable: false,
            newItem: {
                title: "",
                description: "",
                item_type: "owned_case",
                prompt: "",
                uploadedFile: null,
            },
            createType: "create",
            modalLoading: false,
            creationInProgress: false,
            accessModalLoading: false,
            currentPage: this.$store.getters.libraryPageNumber,
            sortField: this.$store.getters.librarySortField,
            sortDescending: this.$store.getters.librarySortDescending,
            communityTermsCheckbox: false,
            hasNavigatedToCommunity: false,
            draggableInstance: null,
            moveToFolder: null,
            resultsPerPage: this.$store.getters.libraryResultsPerPage,
            resultsPerPageOptions: [5, 10, 20, 50],
            caseFormFields: [
                {
                    name: "Title",
                    key: "title",
                    placeholder: "Add a title...",
                    required: true,
                    maxlength: 150,
                },
                {
                    name: "Description",
                    key: "description",
                    placeholder: "Optionally add a description...",
                    type: "textarea",
                    rows: 2,
                    required: false,
                },
            ],
            lmsFormFields: [
                {
                    name: "Publish to My Learning Management System",
                    subtext: `
                        When enabled, this learning experience will be visible to any instructor in your LMS when selecting Affinity content.
                        Turning this setting off won't disable existing usages of this learning experience in your courses.
                    `,
                    key: "show_in_lms_deep_link",
                    type: "switch",
                    required: false,
                },
            ],
        }
    },
    watch: {
        sort() {
            this.fetchData()
        },
        sortDescending(newValue) {
            this.resetCurrentPage()
            this.fetchData()
            this.$store.commit("setLibrarySortDescending", newValue)
        },
        sortField(newValue) {
            this.resetCurrentPage()
            this.fetchData()
            this.$store.commit("setLibrarySortField", newValue)
        },
        currentPage(newValue) {
            this.$store.commit("setLibraryPageNumber", newValue)
        },
        enableLTIGradePassback() {
            // Make sure the success state of the link copy is reset if the user
            // changes passback settings.
            this.$refs.lmsEmbedLink.reset()
        },
        enableLTIPDFPassback() {
            // Make sure the success state of the link copy is reset if the user
            // changes passback settings.
            this.$refs.lmsEmbedLink.reset()
        },
        enableLTIManualGrading() {
            // Make sure the success state of the link copy is reset if the user
            // changes passback settings.
            this.$refs.lmsEmbedLink.reset()
        },
        queryParamsFolderId(newValue) {
            if (!newValue) {
                this.currentFolderId = null
            } else {
                this.currentFolderId = newValue
            }
            this.resetCurrentPage()
            this.fetchData()
            this.$store.commit("setLibraryFolderId", this.currentFolderId)
        },
        resultsPerPage(newValue) {
            this.resetCurrentPage()
            this.fetchData()
            this.$store.commit("setLibraryResultsPerPage", newValue)
        },
    },
    computed: {
        loading() {
            return this.$store.getters.loading
        },
        queryParamsFolderId() {
            return this.$route.query.folder
        },
        userIsOrganizationAdmin() {
            return this.$store.getters.userIsOrganizationAdmin
        },
        organizationId() {
            return this.$store.getters.currentOrganizationId
        },
        queryEntryStart() {
            return this.currentPage * this.resultsPerPage
        },
        queryEntryEnd() {
            return this.currentPage * this.resultsPerPage + this.resultsPerPage
        },
        currentPageStart() {
            return this.queryEntryStart + 1
        },
        currentPageEnd() {
            return Math.min(this.queryEntryStart + this.libraryItems.length, this.folderItemsCount)
        },
        currentItemListEmpty() {
            return this.libraryItems.length === 0 && !this.loading
        },
        currentFolderEmpty() {
            return this.currentItemListEmpty && this.currentFolderId
        },
        numberOfPages() {
            return Math.ceil(this.folderItemsCount / this.resultsPerPage)
        },
        selectedItemCase() {
            if (this.selectedItem && this.selectedItem.case) {
                return this.selectedItem.case
            }
            return {}
        },
        organizationBillingEnabled() {
            return this.$store.getters.organizationBillingEnabled
        },
        organizationLMSAuthConfigured() {
            return this.$store.getters.organizationLMSAuthConfigured
        },
        userCanAccessBillingPortal() {
            return this.organizationBillingEnabled && this.userIsOrganizationAdmin
        },
        caseCapacity() {
            return this.$store.getters.organizationDetails.max_cases
        },
        capacityIsReached() {
            if (this.caseCapacity) {
                return this.orgTotalCaseCount >= this.caseCapacity
            }
            return false
        },
        freeTierActive() {
            return this.$store.getters.organizationDetails.free_tier_active
        },
        creativeCommonsLicenseUrl() {
            return this.$store.getters.creativeCommonsLicenseUrl
        },
        createBtnEnabled() {
            if (this.modalLoading) return false
            if (this.newItem.item_type === 'folder') {
                return this.newItem.folder_name
            } else if (this.createType === "create") {
                return this.newItem.title
            } else {
                return this.newItem.prompt || this.newItem.uploaded_file
            }
        },
        folderItemFormFields() {
            return [
                {
                    placeholder: "Folder Name",
                    key: "folder_name",
                    required: true,
                    maxlength: 150,
                },
            ]
        },
        newItemFormFields() {
            if (this.newItem.item_type === "folder") {
                return this.folderItemFormFields
            } else {
                return this.caseFormFields
            }
        },
        newItemModalTitle() {
            let displayNames = {
                owned_case: "Learning Experience",
                community_reference: "Learning Experience",
                folder: "Folder",
            }
            return displayNames[this.newItem.item_type]
        },
        removeBtnIsEnabled() {
            return this.selectedItemIsRemovable && this.isSelectedItemOwner && !this.modalLoading
        },
        communityBrowseURL() {
            if (this.currentFolder.id) {
                return `/community/browse?addToParent=${this.currentFolder.id}`
            }
            return "/community/browse"
        },
    },
    methods: {
        // Refresh all data for the view.
        async fetchData() {
            if (!this.organizationId) {
                this.$store.dispatch("addLoad")
                await this.$store.dispatch("fetchAuth")
                this.$store.dispatch("removeLoad")
            }

            this.$store.dispatch("addLoad")
            let vm = this
            Promise.all([this.fetchLibraryItems(), this.fetchCaseCounts(), this.fetchCurrentFolder()])
                .then(() => {
                    vm.$nextTick(() => {
                        vm.initDragAndDrop()
                    })
                })
                .finally(() => {
                    this.$store.dispatch("removeLoad")
                })
        },
        // Fetch a count of total cases owned by the organization.
        fetchCaseCounts() {
            let vm = this
            return new Promise((resolve) => {
                http.get(`/api/organizations/${vm.organizationId}/case-count/`).then((response) => {
                    vm.orgTotalCaseCount = response.data.total
                    resolve()
                })
            })
        },
        // Fetch a list of library items.
        fetchLibraryItems() {
            let vm = this
            this.$store.dispatch("addLoad")
            return new Promise((resolve) => {
                http.get("/api/library-items/", {
                    params: {
                        organizationId: vm.organizationId,
                        pageStart: vm.queryEntryStart,
                        pageEnd: vm.queryEntryEnd,
                        sort: vm.sortField,
                        sortDescend: vm.sortDescending,
                        parentItemId: vm.currentFolderId,
                        itemTypes: "owned_case,community_reference,folder",
                    },
                })
                    .then((response) => {
                        vm.libraryItems = response.data.results
                        vm.folderItemsCount = response.data.total_items_count
                        vm.isInitialized = true
                        resolve()
                    })
                    .finally(() => {
                        vm.$store.dispatch("removeLoad")
                    })
            })
        },
        // Fetch details about the current folder being viewed.
        fetchCurrentFolder() {
            let vm = this
            return new Promise((resolve) => {
                if (this.currentFolderId) {
                    http.get(`/api/library-items/${this.currentFolderId}/`).then((response) => {
                        vm.currentFolder = response.data
                        resolve()
                    })
                } else {
                    vm.currentFolder = {
                        parent_items: [],
                    }
                    resolve()
                }
            })
        },
        // Check whether the requester is an owner of the library item.
        checkLibraryItemAccess(accessType = "owner") {
            this.isSelectedItemOwner = false
            let vm = this
            return new Promise((resolve) => {
                http.get(`/api/library-items/${this.selectedItem.id}/check-permissions/?accessType=${accessType}`).then(
                    (response) => {
                        vm.isSelectedItemOwner = response.data.has_permission
                        resolve(response.data.has_permission)
                    }
                )
            })
        },
        // Open the create item modal.
        openCreateItem(newItemType) {
            // Initialize item for editing.
            this.newItem = {
                item_type: newItemType,
                title: "",
                description: "",
                prompt: "",
                uploaded_file: null,
                parent_item_id: this.currentFolder.id,
            }
            this.createType = "create"

            // Check the organization's capacity.
            if (newItemType === "owned_case" && this.capacityIsReached) {
                $("#cap-reached-modal").modal("show")
                return
            }

            // Reset form validation.
            this.$refs.createCaseForm.resetValidate()
            this.$refs.createFolderForm.resetValidate()
            $("#create-modal").modal("show")
        },
        // Open the remove modal.
        openRemoveItem(item) {
            this.modalLoading = true
            this.selectedItemIsRemovable = true
            this.selectedItem = item
            $("#remove-modal").modal("show")
            this.checkLibraryItemAccess()
            let vm = this
            http.get(`/api/library-items/${this.selectedItem.id}/remove/`)
                .then((response) => {
                    vm.selectedItemIsRemovable = response.data.is_removable
                })
                .finally(() => {
                    vm.modalLoading = false
                })
        },
        // Open the move item modal.
        openMoveItem(item) {
            this.$refs.folderSelector.searchDebounced("")
            this.selectedItem = item
            $("#move-modal").modal("show")
            this.checkLibraryItemAccess()
        },
        // Open the clone case modal.
        openCloneItem(item) {
            if (this.capacityIsReached) {
                $("#cap-reached-modal").modal("show")
                return
            }
            this.selectedItem = item
            if (item.item_type === "community_reference") {
                $("#editable-clone-modal").modal("show")
            } else {
                $("#clone-modal").modal("show")
            }
        },
        // Open the edit folder modal.
        openEditFolder(item) {
            this.selectedItem = Object.assign({}, item)
            $("#folder-edit-modal").modal("show")
        },
        // Open the item access modal.
        openEditItemAccess(item) {
            this.selectedItem = item
            $("#item-access-modal").modal("show")
        },
        // Open the LMS embed modal.
        openLMSEmbedModal(item) {
            if (!this.organizationLMSAuthConfigured) {
                $("#lms-not-configured-modal").modal("show")
                return
            }
            this.showLMSSteps = false
            this.enableLTIGradePassback = false
            this.selectedItem = item
            $("#lms-embed-modal").modal("show")
            let vm = this
            this.$nextTick(() => {
                vm.$refs.ltiLaunchForm.resetForm()
            })
        },
        // Open the community publish modal.
        openPublish(item) {
            this.selectedItem = item
            this.$refs.communityPublishModal.open()
        },
        // Move an item to a new location.
        moveItem() {
            this.moveItemById(this.selectedItem.id, this.moveToFolder.id).then(() => {
                $("#move-modal").modal("hide")
            })
        },
        // Move an item with a given ID to a folder with a given ID.
        moveItemById(itemId, locationId) {
            this.$store.dispatch("addLoad")
            let vm = this
            // Move the item into the new folder.
            return new Promise((resolve) => {
                http.put(`/api/library-items/${itemId}/move/`, {
                    targetFolderId: locationId,
                })
                    .then(() => {
                        vm.$notify({
                            group: "main",
                            type: "success",
                            text: "Item moved.",
                            data: {},
                        })
                        vm.fetchData()
                        resolve()
                    })
                    .finally(() => {
                        vm.$store.dispatch("removeLoad")
                    })
            })
        },
        // Create a new library item.
        createItem() {
            this.creationInProgress = true
            let createType = this.createType === "prompt" ? "prompt" : "blank"
            this.newItem.create_type = createType
            this.modalLoading = true
            let vm = this
            http.post("/api/library-items/", {
                ...this.newItem,
                organizationId: this.organizationId,
            })
                .then(function (response) {
                    $("#create-modal").modal("hide")
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: `${vm.newItemModalTitle} created.`,
                        data: {},
                    })
                    // Switch to the first page so that the new item is shown.
                    vm.resetCurrentPage()
                    if (response.data.item_type == "owned_case") {
                        // Navigate to the new case.
                        vm.$router.push({ name: "CaseNodeMap", params: { id: response.data.case.id } })
                    }
                    vm.fetchData()
                })
                .finally(function () {
                    vm.modalLoading = false
                    vm.creationInProgress = false
                })
        },
        // Remove an item.
        removeItem() {
            this.modalLoading = true
            let vm = this
            http.put(`/api/library-items/${this.selectedItem.id}/remove/`)
                .then(function () {
                    $("#remove-modal").modal("hide")
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Learning Experience removed.",
                        data: {},
                    })
                    if (vm.libraryItems.length === 1 && vm.currentPage > 0) {
                        // Removing the last item on the current page, so go to the previous page.
                        vm.currentPage--
                    }
                    vm.fetchData()
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
        // Clone an item.
        cloneItem() {
            this.modalLoading = true
            let vm = this
            http.post(`/api/library-items/${this.selectedItem.id}/clone/`)
                .then(function () {
                    $("#clone-modal").modal("hide")
                    $("#editable-clone-modal").modal("hide")
                    // Switch to the first page so that the new item is shown.
                    vm.resetCurrentPage()
                    vm.fetchData()
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Learning Experience cloned.",
                        data: {},
                    })
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
        // Update a folder item.
        saveFolder() {
            this.modalLoading = true
            let vm = this
            http.put(`/api/library-items/${this.selectedItem.id}/`, {
                folder_name: this.selectedItem.folder_name,
            })
                .then(function () {
                    $("#folder-edit-modal").modal("hide")
                    vm.fetchData()
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Item updated.",
                        data: {},
                    })
                })
                .finally(function () {
                    vm.modalLoading = false
                })
        },
        // Reset back to the first page of items.
        resetCurrentPage() {
            this.currentPage = 0
        },
        // Set the current page being viewed.
        setCurrentPage(pageIndex) {
            this.currentPage = pageIndex
            this.fetchLibraryItems()
        },
        // Get a display-name for a given sort field.
        sortFieldDisplay(sortField) {
            const sortFieldNames = {
                title: "Title",
                last_modified: "Last Modified",
            }
            return sortFieldNames[sortField]
        },
        // Format a date object as a string.
        formatDateTime(dateObj) {
            return Utilities.formatDateTime(dateObj)
        },
        // Returns a link to the community view for a published case.
        viewInCommunityLink(item) {
            return this.$router.resolve({ name: "CommunityCaseDetail", params: { id: item.case.id } }).href
        },
        // Called when a user opens the community library in a new tab.
        browseCommunityLibrary() {
            this.hasNavigatedToCommunity = true
        },
        // Handle a user closing the create modal.
        handleCreateClosed() {
            // User may have added community scenarios in an external tab, so reload them.
            if (this.hasNavigatedToCommunity) {
                this.fetchData()
                this.hasNavigatedToCommunity = false
            }
        },
        // Trim a string to the desired length, for display.
        trimString(str, length) {
            return Utilities.trimString(str, length)
        },
        // Initialize drag and drop actions for moving library items between folders.
        initDragAndDrop() {
            if (this.draggableInstance) {
                return
            }
            this.draggableInstance = new Draggable(document.querySelectorAll("[data-drag-drop-container='true']"), {
                draggable: "[data-drag-drop=true]",
                // Applies classes to elements during drag and drop.
                classes: {
                    mirror: ["drag-mirror"],
                    "draggable:over": ["is-dragged-over"],
                    "source:dragging": ["is-dragging-source"],
                },
                // Set the mirror/ghost offset from the cursor when dragging
                mirror: {
                    cursorOffsetX: 10,
                    cursorOffsetY: 10,
                },
                // Prevents click actions from being captured by drag and drop actions.
                distance: 5,
            })

            let vm = this
            // Handle a drop action.
            this.draggableInstance.on("drag:stop", async (event) => {
                // Get the ID of the dropped item.
                let itemId = event.source.getAttribute("data-item-id")
                if (!itemId) {
                    return
                }
                // Find the library item being dragged over.
                let draggedOverEl = document.querySelector(".is-dragged-over")
                if (!draggedOverEl) {
                    return
                }
                let draggedOverId = draggedOverEl.getAttribute("data-item-id")
                if (!draggedOverId) {
                    return
                }
                let droppedOnItem
                if (draggedOverId === "root") {
                    // Item was dropped on the 'library' breadcrumb link - means the user wants
                    // to move the item to the root folder.
                    droppedOnItem = {
                        id: null,
                    }
                } else {
                    // Find the folder (library item) that the item was dropped on top of.
                    let allDroppableItems = vm.libraryItems.concat(vm.currentFolder.parent_items)
                    droppedOnItem = allDroppableItems.find((i) => i.id === draggedOverId)
                    if (!droppedOnItem || droppedOnItem.item_type !== "folder") {
                        return
                    }
                }
                // Check that the item isn't being moved into itself.
                if (droppedOnItem.id === itemId) {
                    return
                }
                // Check the user has permission to move the item.
                vm.$store.dispatch("addLoad")
                vm.selectedItem = vm.libraryItems.find((i) => i.id === itemId)
                let hasPermission = await vm.checkLibraryItemAccess()
                if (!hasPermission) {
                    $("#move-permission-modal").modal("show")
                } else {
                    vm.moveItemById(itemId, droppedOnItem.id)
                }
                vm.$store.dispatch("removeLoad")
            })

            // This is used to cancel drag actions on certain items that can only be dropped
            // onto (i.e. folder breadcrumbs).
            this.draggableInstance.on("drag:start", (event) => {
                let allowDrag = event.source.getAttribute("data-drop-only")
                if (allowDrag === "true") {
                    event.cancel()
                }
            })
        },
        // Formats a number for displaying view count.
        formatViewCount(count) {
            return Utilities.formatViewCount(count)
        },
        // Returns text describing whether an item is visible in the organization's LMS.
        getItemLMSStatusText(item) {
            let relevantItem = item.item_type === "community_reference" ? item : item.case
            if (relevantItem.show_in_lms_deep_link) {
                return "This learning experience is selectable in your LMS"
            }
            return "This learning experience is not selectable in your LMS"
        },
        // Open the edit case modal.
        async openEditCase(item) {
            this.$refs.editCaseForm.resetValidate()
            this.isSelectedItemEditor = true
            this.modalLoading = true
            this.selectedItem = item
            this.selectedCase = Object.assign({}, item.case)
            this.$refs.caseEditModal.show()
            this.isSelectedItemEditor = await this.checkLibraryItemAccess("editor")
            this.modalLoading = false
        },
        // Open the LMS settings modal.
        async openLMSSettingsModal(item) {
            if (!this.organizationLMSAuthConfigured) {
                $("#lms-not-configured-modal").modal("show")
                return
            }
            this.isSelectedItemEditor = true
            this.modalLoading = true
            this.selectedItem = item
            this.selectedCase = Object.assign({}, item.case)
            this.$refs.lmsSettingsModal.show()
            this.isSelectedItemEditor = await this.checkLibraryItemAccess("editor")
            this.modalLoading = false
        },
        // Save LMS deep linking setting for the selected case.
        async saveLMSSettings() {
            let vm = this
            this.modalLoading = true
            if (this.selectedItem.item_type === "owned_case") {
                await http
                    .put(`/api/cases/${this.selectedItem.case.id}/settings/basic/`, {
                        show_in_lms_deep_link: this.selectedCase.show_in_lms_deep_link,
                    })
                    .finally(() => (vm.modalLoading = false))
            } else {
                await http
                    .put(`/api/library-items/${this.selectedItem.id}/`, {
                        show_in_lms_deep_link: this.selectedItem.show_in_lms_deep_link,
                    })
                    .finally(() => (vm.modalLoading = false))
            }
            // Make sure the new value is reflected in the library view.
            vm.selectedItem.case.show_in_lms_deep_link = vm.selectedCase.show_in_lms_deep_link
            vm.$refs.lmsSettingsModal.hide()
            vm.$notify({
                group: "main",
                type: "success",
                text: "LMS settings updated.",
                data: {},
            })
        },
        // Save basic case settings.
        saveCaseSettings() {
            // Check form validity.
            if (!this.$refs.editCaseForm.validate()) {
                return
            }
            let vm = this
            this.modalLoading = true
            http.put("/api/cases/" + this.selectedItem.case.id + "/settings/", this.selectedCase)
                .then(() => {
                    vm.fetchData()
                    vm.$refs.caseEditModal.hide()
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Item saved.",
                        data: {},
                    })
                })
                .finally(() => {
                    vm.modalLoading = false
                })
        },
    },
    created() {
        this.currentFolderId = this.$route.query.folder || null
        this.fetchData()
    },
    beforeDestroy() {
        if (this.draggableInstance) {
            this.draggableInstance.destroy()
        }
    },
    beforeRouteLeave(to, from, next) {
        $("#create-modal").modal("hide")
        if (!to.meta || to.meta.parent !== "CaseDetail") {
            // Reset search and sort parameters if navigating to a different area of the application.
            this.$store.commit("resetLibraryView")
        }
        next()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

$folder-hover-bg: #115fde29;

.view-header {
    min-height: 54px;
}

.list-divider {
    margin-top: 22px;
    margin-bottom: 22px;
}

.case-cover-container {
    @media (min-width: ($breakpoint-md)) {
        padding-top: 10px;
        padding-bottom: 10px;
    }
}

.tab-nav {
    margin-right: 10px;
    font-size: 15px;
}

.metadata-container {
    max-width: 630px;
}

.library-item-container {
    margin-right: 32px;
}

.folder-container {
    .is-dragged-over:not(.is-dragging-source) {
        .folder-icon-container {
            background-color: $folder-hover-bg;
        }
        .folder-icon {
            color: lighten($primary, 5%) !important;
        }
    }
}

.folder-icon-container {
    height: $lib-item-height;
    width: $lib-item-width;
    background-color: $light; // #f1f4f8
    border-radius: $border-radius-lg;
    padding: 10px;
    transition: $transition-base;
}

.folder-icon {
    font-size: 55px;
    color: $folder-color;
    border-radius: $border-radius-lg;
    padding: 0px;
    margin: -1px;
    transition: $transition-base;
}

.folder-text {
    line-height: 1;
}

.breadcrumb-chevron {
    padding-left: 5px;
    padding-right: 5px;
    font-size: 80%;
}

.nav-item {
    &.is-dragged-over {
        .breadcrumb-item {
            transform: scale(1.1);
            background-color: $folder-hover-bg !important;
            color: $primary;
        }
    }
}

.breadcrumb-item {
    font-weight: 500;
    border-radius: $border-radius;
    padding: 0.3rem 0.6rem;
    color: #4c535b;
    background-color: lighten($nav-bg-active, 20%);
    cursor: pointer;
    &:hover {
        color: $gray-800;
        background-color: $nav-bg-active;
    }
    &.active {
        color: $primary;
    }
    transition: $transition-base;
}

.drag-mirror {
    height: 60px !important;
    width: 90px !important;
    .folder-icon-container {
        height: $lib-item-height * 0.5 !important;
        width: $lib-item-width * 0.5 !important;
        box-shadow: $box-shadow-sm;
        .folder-icon {
            scale: 0.5;
        }
        .folder-text {
            display: none;
        }
    }
}

.community-watermark {
    position: absolute;
    right: 6px;
    bottom: 14px;
    color: #ffffff;
    font-size: 24px;
}

.create-item-label {
    margin-bottom: 2px;
}

.tab-nav-link {
    padding: 12px;
}

.shines-icon {
    height: 16px;
    margin-top: 2px;
    margin-bottom: 4px;
}
</style>

<style lang="scss">
.drag-mirror {
    .cover-placeholder {
        scale: 0.7;
    }
}
</style>
